module.exports = __webpack_public_path__ + "img/sld_scb_3_t1_green.6e53cce3.svg";